import { useEffect, useRef } from 'react'
// @ts-expect-error — @toast-ui/editor 의 viewer entry 는 type 미포함
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer'
import '@toast-ui/editor/dist/toastui-editor.css'
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css'

interface MarkdownViewerProps {
  content: string
  dark?: boolean
}

export function MarkdownViewer({ content, dark }: MarkdownViewerProps) {
  const ref = useRef<HTMLDivElement>(null)
  const viewerRef = useRef<{ destroy: () => void; setMarkdown: (s: string) => void } | null>(null)

  useEffect(() => {
    if (!ref.current) return
    const el = ref.current
    const v = new Viewer({
      el,
      initialValue: content,
      theme: dark ? 'dark' : 'light',
    }) as { destroy: () => void; setMarkdown: (s: string) => void }
    viewerRef.current = v
    return () => {
      v.destroy()
      // Toast UI Viewer 가 wrapping DOM/class 잔존 시키는 케이스 방지 — 명시적 reset
      el.innerHTML = ''
      viewerRef.current = null
    }
  }, [dark]) // 다크 토글 시 재생성

  useEffect(() => {
    viewerRef.current?.setMarkdown(content)
  }, [content])

  // dark 클래스를 React 가 직접 관리 — viewer destroy 후에도 stale dark style 남지 않게
  return <div ref={ref} className={`markdown-body${dark ? ' toastui-editor-dark' : ''}`} />
}
